const syncWizardBoothStaff = (root = document) => {
  const fields = root.querySelector("[data-wizard-booth-staff-fields]")
  const radios = root.querySelectorAll("[data-wizard-booth-staff]")
  if (!fields || !radios.length) return

  const yes = Array.from(radios).find((radio) => radio.value === "true" && radio.checked)
  fields.classList.toggle("d-none", !yes)
  if (!yes) {
    fields.querySelectorAll("input").forEach((input) => {
      input.value = ""
    })
  }
}

const boothStaffIsIncomplete = () => {
  const fields = document.querySelector("[data-wizard-booth-staff-fields]")
  if (!fields || fields.classList.contains("d-none")) return false

  return Array.from(fields.querySelectorAll("input")).some((input) => !input.value.trim())
}

let initialized = false

export const initWizardBoothStaff = () => {
  syncWizardBoothStaff()
  if (initialized) return
  initialized = true

  document.addEventListener("change", (event) => {
    if (!(event.target instanceof HTMLElement)) return
    if (!event.target.matches("[data-wizard-booth-staff]")) return
    syncWizardBoothStaff()
  })

  // En capture : les écouteurs du bouton « Valider » soumettent deux formulaires
  // et font avancer l'étape, il faut donc les court-circuiter avant eux.
  document.addEventListener(
    "click",
    (event) => {
      if (!(event.target instanceof HTMLElement)) return
      if (!event.target.closest(".edit-exhibitor-products-fake-submit-btn")) return
      if (!boothStaffIsIncomplete()) return

      event.preventDefault()
      event.stopPropagation()
      if (window.showSiteAlert) {
        window.showSiteAlert({ html: "Veuillez renseigner les informations du standiste" })
      } else if (window.Swal) {
        window.Swal.fire({ html: "Veuillez renseigner les informations du standiste" })
      }
    },
    true
  )
}
